export const formDataSaqA = [
  // Page 09
  {
    _uid: "e9f0354a-d2d4-457f-a3c0-212b1ede86c0",
    layout: "form",
    component: "page",
    title: "Assessment Information",
    label: "Instructions for Submission",
    simplifiedLabel: "",
    caption:
      "This document must be completed as a declaration of the results of the merchant’s self-assessment against the Payment Card Industry Data Security Standard (PCI DSS) Requirements and Testing Procedures. Complete all sections. The merchant is responsible for ensuring that each section is completed by the relevant parties, as applicable. Contact the entity(ies) to which the Attestation of Compliance (AOC) will be submitted for reporting and submission procedures.",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "d8286d28-f60b-43c2-b392-f969ad4993bb",
        component: "text",
        type: "text",
        label: "Company Name",
        simplifiedLabel: "Company Name",
        maxLength: "120",
      },
      {
        _uid: "5174ec78-8bc2-43d7-ba07-cff93ab2e737",
        component: "text",
        type: "text",
        label: "DBA (doing business as):",
        simplifiedLabel: "DBA (doing business as):",
        maxLength: "120",
      },
      {
        _uid: "4595839c-90fc-4692-84dc-a4597e635b13",
        component: "text",
        type: "text",
        label: "Company mailing address:",
        simplifiedLabel: "Company mailing address:",
        maxLength: "120",
      },
      {
        _uid: "7e6768ef-c046-4d39-82d0-6bdc6af3f79d",
        component: "text",
        type: "text",
        label: "Company main website:",
        simplifiedLabel: "Company main website:",
        maxLength: "120",
      },
      {
        _uid: "0ab0a774-b4c2-43fe-bcfc-77155900ae1c",
        component: "text",
        type: "text",
        label: "Company contact name:",
        simplifiedLabel: "Company contact name:",
        maxLength: "58",
      },
      {
        _uid: "a67c6ac6-d624-4843-bbfb-947dff788695",
        component: "text",
        type: "text",
        label: "Company contact title:",
        simplifiedLabel: "Company contact title:",
        maxLength: "120",
      },
      {
        _uid: "68ef902a-7f26-43c4-b493-ceab3c6d69e2",
        component: "text",
        type: "text",
        label: "Contact phone number:",
        simplifiedLabel: "Contact phone number:",
        maxLength: "120",
      },
      {
        _uid: "248627b6-0c99-402d-9ab8-1118f4fbca46",
        component: "text",
        type: "text",
        label: "Contact e-mail address:",
        simplifiedLabel: "Contact e-mail address:",
        maxLength: "120",
      },
      {
        _uid: "efcc2336-cfb1-4dbf-96c7-7ed83b9b1894",
        component: "label",
        type: "",
        label:
          "Provide the following information for all assessors involved in the assessment. If there was no assessor for a given assessor type, followings are Not Applicable.",
        simplifiedLabel: "",
        maxLength: "120",
      },
      {
        _uid: "7dd93e19-49cb-430c-b1f3-8841a5aba091",
        component: "label",
        type: "",
        label: "PCI SSC Internal Security Assessor(s)",
        simplifiedLabel: "",
        maxLength: "13",
      },
      {
        _uid: "76603005-75e8-4992-b248-da95ddcdbe4b",
        component: "text",
        type: "text",
        label: "ISA name(s):",
        simplifiedLabel: "",
        maxLength: "13",
        col: "12",
      },
      {
        _uid: "c8d8d852-50fd-4440-8082-814073afe5eb",
        component: "label",
        type: "",
        label: "Qualified Security Assessor",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bfa8f531-460c-4b37-8743-fd09797942b4",
        component: "text",
        type: "text",
        label: "Company name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "39ba999d-b41a-4fcb-8312-aa1a05c16d87",
        component: "text",
        type: "text",
        label: "Company mailing address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "e3b3b310-9079-4df9-8767-d152a7e1b6f7",
        component: "text",
        type: "text",
        label: "Company website:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "862d75b4-2710-42cc-be34-26c82a56d8a6",
        component: "text",
        type: "text",
        label: "Lead Assessor Name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bea46930-82b4-40ac-9d2b-a40254c9c4f4",
        component: "text",
        type: "text",
        label: "Assessor phone number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "91e3cf83-2ff3-438f-b828-b4ff656533b3",
        component: "text",
        type: "text",
        label: "Assessor e-mail address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "4bdda341-517c-44a9-ac6e-cecbd8800af6",
        component: "text",
        type: "text",
        label: "Assessor certificate number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
    ],
  },
  // Page 10
  {
    _uid: "a465fe58-b84c-453d-b45a-fe96e6b60f4d",
    layout: "form",
    component: "page",
    title: "",
    label: "",
    simplifiedLabel: "Part 2. Executive Summary",
    caption: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "2a1a0ed9-9510-468c-b574-f1d5d6bb6904",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [
          "Part 2a. Merchant Business Payment Channels (select all that apply):",
          "Indicate all payment channels used by the business that are included in this assessment.",
        ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "e0119add-86a8-4c41-9c89-edcdef842b86",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Mail order/telephone order (MOTO)",
                value: "Mail order/telephone order (MOTO)",
                col: 4,
              },
              {
                _uid: "3337cc28-09e7-43c5-b42f-1bcf81b2b336",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "E-Commerce",
                value: "E-Commerce",
                col: 4,
              },
              {
                _uid: "e8608b32-69d1-4030-a480-5ed6db79117d",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Card-present",
                value: "Card-present",
                col: 4,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "756ddf69-eb1c-4961-a641-89f2b2cf22d5",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Are any payment channels not included in this assessment?",
                  "If yes, indicate which channel(s) is not included in the assessment and provide a brief explanation about why the channel was excluded.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "70%",
                colSpan: "2",
              },
              {
                _uid: "becc5fbd-536b-4344-a8f2-569560cdcf83",
                component: "col",
                label:
                  "Are any payment channels not included in this assessment? If yes, indicate which channel(s) is not included in the assessment and provide a brief explanation about why the channel was excluded. ",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "30%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: ["749517be-72d5-4ee7-901e-f552c88613b9"],
                },
              },

              {
                fields: [
                  {
                    _uid: "0065e5cb-b0ed-4429-a145-6f94291d08b2",
                    component: "col",
                    label: "",
                    simplifiedLabel: [
                      "Note: If the organization has a payment channel that is not covered by this SAQ, consult with the entity(ies) to which this AOC will be submitted about validation for the other channels.",
                    ],
                    hasLi: "no",
                    type: "",
                    col: "12",
                    width: "100%",
                    colSpan: "3",
                  },
                ],
              },
            ],
          },
          {
            _uid: "aa6afd24-2d95-46f1-be04-46f7326f952d",
            component: "table",
            label: "",
            simplifiedLabel: "",
            type: "table",
            caption: "",
            simplifiedCaption: [""],
            headers: "",
            conditional: {
              value: "yes",
              field:
                "3d372174-4078-49b6-9853-99439a9c3ca0_becc5fbd-536b-4344-a8f2-569560cdcf83",
            },
            fields: [
              {
                fields: [
                  {
                    _uid: "749517be-72d5-4ee7-901e-f552c88613b9",
                    component: "col",
                    label: "",
                    simplifiedLabel: [],
                    hasLi: "",
                    type: "textarea",
                    textareaRows: "8",
                    col: "12",
                    width: "100%",
                    marginBottom: 450,
                  },
                ],
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f892cf83-57a2-4ca2-9462-677052bd693a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Note: If the organization has a payment channel that is not covered by this SAQ, consult with the entity(ies) to which this AOC will be submitted about validation for the other channels.",
                  ,
                ],
                boldLabel: "Part 2b. Description of Role with Payment Cards",
                subBoldLabel:
                  "For each payment channel included in this assessment as selected in Part 2a above, describe how the business stores, processes, and/or transmits account data.",
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 3,
                width: "100%",
                conditional: {
                  value: "yes",
                  field:
                    "786da4a1-6f7a-4b4b-9a77-78b81c142841_becc5fbd-536b-4344-a8f2-569560cdcf83",
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "efdd7555-1f29-458b-a1dd-816e87283495",
        component: "table",
        showSimplifiedOptions: true,
        boldCaption: ["Part 2b. Description of Role with Payment Cards"],
        simplifiedNotes:
          "For each payment channel included in this assessment as selected in Part 2a above, describe how the business stores, processes, and/or transmits account data.",
        type: "table",
        caption: "",
        headers: [
          "Channel",
          "How Business Stores, Processes, and/or Transmits Account Data",
        ],
        /* conditional: {
          value: "yes",
          field:
            "9cd9ade3-19c3-4d87-b053-b9e0b6a48321_becc5fbd-536b-4344-a8f2-569560cdcf83",
        }, */
        fields: [
          {
            fields: [
              {
                _uid: "d18c2852-aa25-417d-875e-4e4df19e01c3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "f6a6fedd-d5ed-4ad3-9bca-f4db89ace559",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "36804892-0122-42c9-a8dc-cfe8252a1fa6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "d7f6d72c-e605-444e-be81-0ca0271b6748",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2f961a8b-4b0c-4566-8952-5f6b7c7fbf9d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "40",
              },
              {
                _uid: "cc5d42b9-2842-4d02-be70-b6083baf0bd8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "60%",
                maxLength: "75",
              },
            ],
          },
        ],
      },
      {
        _uid: "31a9db8f-58ef-4652-98ce-b95eac326dff",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: ["Part 2c. Description of Payment Card Environment"],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "2bde7286-8572-48ce-9ad4-e87e48e35b54",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Provide a high-level description of the environment covered by this assessment.",
                  "For example:",
                  "Connections into and out of the cardholder data environment (CDE).",
                  "Critical system components within the CDE, such as POI devices, databases, web servers, etc., and any other necessary payment components, as applicable.",
                  "System components that could impact the security of account data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "65c8932a-c344-4919-bd76-f9040a57ec25",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: 500,
                col: "12",
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2c352136-6c7c-47b7-a88b-13c9381f4982",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Indicate whether the environment includes segmentation to reduce the scope of the assessment.",
                  "(Refer to “Segmentation” section of PCI DSS for guidance on segmentation.)",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "70%",
              },

              {
                _uid: "d64b5973-1566-43e1-9b8f-874b1fde5985",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "30%",
                doNotDisplayLabel: "",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 11
  {
    _uid: "d5869fe8-b683-4af8-8f4d-9e078a6397d7",
    layout: "form",
    component: "page",
    title: "",
    label: "",
    simplifiedLabel: "Part 2. Executive Summary (continued)",
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "c928b6b0-95c5-4f74-97f9-aa4337210a12",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "e3ad86e1-1c6e-4073-a9f4-da9860600702",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2d. In-Scope Locations/Facilities",
                subBoldLabel:
                  "List all types of physical locations/facilities (for example, retail locations, corporate offices, data centers, call centers, and mail rooms) in scope for the PCI DSS assessment.",
                hasLi: "yes",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
        ],
      },
      {
        _uid: "f532f41b-7a47-4164-9665-2d6497998370",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: [
          "Facility Type",
          [
            "Total number of locations",
            "(How many locations of this type are in scope)",
          ],
          "Location(s) of facility (city, country)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "f538e4fb-d0ac-4a62-a9f2-528eda4a4e10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "acf5d0af-3f42-442f-800e-4d6c222b6351",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "9d917ce7-1041-4f79-870f-1b4c39ee603c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4e21fb8b-f941-41a2-baba-728508c9d5e7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "cc43fff6-bf6d-4fd2-8f27-dd05739eb088",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "8976e226-42f4-4623-873e-253d2e9b813a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7dafe126-42b5-43ad-af9d-f9b1c04292d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "43",
              },
              {
                _uid: "99d91a88-dc68-4ccd-86b5-f9062f0634cd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "87469c76-72f0-4c65-a4aa-3ad546651328",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3fd13af2-ff06-4a89-8065-49d9312289b9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "38480e9b-5ba4-4c37-be48-32033a5f1cce",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "afe658c1-09ca-43bc-a1c6-d9c27d50930a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a41379e-f356-4293-a495-5feee49f0b73",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "003752c8-ce7b-4082-963b-e822647a915f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "6bbac7ef-44fe-418f-aa3d-033ff84d30f2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e172cf04-218b-4289-b04f-0da438a8df10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "51a688d4-e852-409b-b521-49ca21d681e6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "14f3a088-0a71-4190-af9c-dddfc05edcd7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "216d893f-c246-4c7a-a4ba-6bc4bd82a3d2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "a1709a35-c76f-40e5-9163-b022945aef2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "a38dbab5-d50b-48e7-a952-1aa490b4186e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be1c6190-cf0d-4811-a1d5-2a0ccac73702",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
              {
                _uid: "57fb74a7-b50f-4792-9291-32d1fb8a80be",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "66f7fe42-0057-4e43-84cc-cf28e2577ab1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "42",
              },
            ],
          },
        ],
      },
      {
        _uid: "a89467ec-e1b2-4db7-9910-d0bb46c97936",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "328cb050-79f9-4945-a06c-50feba6d6f5a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2e. PCI SSC Validated Products and Solutions",
                subBoldLabel: "",
                hasLi: "yes",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8dc8633d-b76c-46cb-9d7f-945fba5fe4ab",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Does the merchant use any item identified on any PCI SSC Lists of Validated Products and Solutions*?",
                boldLabel: "",
                subBoldLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "cd991465-68c7-49d9-82ba-2769db9bb9f8",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "20%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [
                    "857d8004-08b2-4aea-b555-d72df62dce09",
                    "af826cd7-9a19-4125-a398-1daca49c93b0",
                    "2825014b-e992-463f-bc4a-9cf9195e509a",
                    "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                    "6ae39d41-7512-4548-8961-587d4df0197a",
                    "4ea9b5d7-3616-46bf-ac0a-53ae99959724",
                    "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                    "f971e7b0-2b1f-40af-a24f-83429fc13077",
                    "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                    "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                    "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                    "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                    "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                    "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                    "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                    "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                    "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                    "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                    "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                    "da5394e3-10e8-4508-baa3-81999f827530",
                    "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                    "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                    "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                    "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                    "10858523-2cc8-42fe-8c64-b81d620b5602",
                    "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                    "70398dd7-a086-45ac-b91e-72912d800505",
                    "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                    "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                    "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                    "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                    "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                    "72e92d2c-0158-4ab3-8194-2ab827652d49",
                    "73dc086f-719a-43ad-a5a4-77ae1e702737",
                    "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                    "1e5f30f3-db60-41fc-be94-99394652aab5",
                    "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                    "470582c3-2690-4bdc-9482-c21593e80306",
                    "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                    "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                    "8413cd02-9a1e-4e99-a021-da94cb98964d",
                    "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                    "d82e5669-4111-45c0-ac13-2fba7e575e91",
                    "3e0115af-7b42-481f-acee-badb6ed4cee9",
                    "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                    "da9bd7e1-7756-4680-9791-7f6e96431209",
                    "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                    "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                    "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                    "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "025ab84f-6a71-4eb7-8f04-2689074c13ab",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: [
          "Name of PCI SSCvalidated Product or Solution",
          "Version of Product or Solution",
          "PCI SSC Standard to which product or solution was validated",
          "PCI SSC listing reference number",
          ["Expiry date of listing", "(YYYY-MM-DD)"],
        ],
        conditional: {
          value: "yes",
          field:
            "51ca7282-7b1f-4a2f-b782-79be8343e7c1_cd991465-68c7-49d9-82ba-2769db9bb9f8",
        },
        fields: [
          {
            fields: [
              {
                _uid: "857d8004-08b2-4aea-b555-d72df62dce09",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "af826cd7-9a19-4125-a398-1daca49c93b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "2825014b-e992-463f-bc4a-9cf9195e509a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "6ae39d41-7512-4548-8961-587d4df0197a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "f971e7b0-2b1f-40af-a24f-83429fc13077",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "4ea9b5d7-3616-46bf-ac0a-53ae99959724",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da5394e3-10e8-4508-baa3-81999f827530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "10858523-2cc8-42fe-8c64-b81d620b5602",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "70398dd7-a086-45ac-b91e-72912d800505",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "73dc086f-719a-43ad-a5a4-77ae1e702737",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "72e92d2c-0158-4ab3-8194-2ab827652d49",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "470582c3-2690-4bdc-9482-c21593e80306",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "1e5f30f3-db60-41fc-be94-99394652aab5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "3e0115af-7b42-481f-acee-badb6ed4cee9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "d82e5669-4111-45c0-ac13-2fba7e575e91",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "8413cd02-9a1e-4e99-a021-da94cb98964d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da9bd7e1-7756-4680-9791-7f6e96431209",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "320",
              },
              {
                _uid: "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "320",
              },
              {
                _uid: "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "320",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 12
  {
    _uid: "4458e8f7-e370-4374-9236-fedb568d386c",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: ["Part 2. Executive Summary (continued)"],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "12dd2ae9-c92c-4cbb-a27b-508800ccd13d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "64c692c1-9203-42d1-afd0-4f9f92f1c627",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2f. Third-Party Service Providers",
                subBoldLabel:
                  "Does the merchant have relationships with one or more third-party service providers that:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "77a713ed-4ff6-452a-b734-da1efd99d5ca",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Store, process, or transmit account data on the merchant’s behalf (for example, payment gateways, payment processors, payment service providers (PSPs), and off-site storage)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "f6008d00-b75a-4365-ba05-d8bf3ecbc1ef",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6db36531-1ce3-4165-b52d-9a2374fb8c42",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Manage system components included in the scope of the merchant’s PCI DSS assessment⎯for example, via network security control services, anti-malware services, security incident and event management (SIEM), contact and call centers, web-hosting services, and IaaS, PaaS, SaaS, and FaaS cloud providers.",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "81f787dd-10d8-46b1-a23a-ee14b6023f9d",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "23c7a84b-4643-4273-b554-3f91d30b3e77",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Could impact the security of the merchant’s CDE (for example, vendors providing support via remote access, and/or bespoke software developers)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "8f9739c3-7fc5-4f0c-b332-f162c9d7aed1",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: ["no"],
                  _uids: [],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "078a098c-1de1-42b0-a949-53901fb446b1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: "",
        marginBottom: 0,
        fields: [
          {
            fields: [
              {
                _uid: "",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "If Yes:",
                subBoldLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
        ],
      },
      {
        _uid: "2f338460-a095-4ffb-b4a8-22a3d9fb5893",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: [
          "Name of service provider:",
          "Description of service(s) provided:",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "f35caf1e-3a60-4746-9ef5-d007213511dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "28bfc7d7-e540-4e88-95a2-547518438ba6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84b9c58d-9986-4eb0-bc08-7f8cf0c0e524",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "fbd53ce8-3f9e-46b0-aabe-79323c139bfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fd603daf-0b36-4383-aeeb-f58e5692e985",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "399fb414-c456-4931-8808-33c05cfab7bc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eb0bc36b-82dc-40fa-b7aa-7ff5e0af4cfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "0101ea03-da19-4f76-a45b-857dfb4ee9f4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1970ac65-2a00-4f3c-b8d2-5c21077d1719",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "42aeb606-9f62-40f7-99b3-a1f6b12a4b5a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d23c6de6-160a-40e4-b881-e498e2d51259",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "64a6951d-2d21-42ab-9f79-cd0f3366382e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fe9f7390-8933-4d12-8a05-df59c6cdf31e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "ef7743a3-aa47-45c9-949d-685025e9f75c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8c646ef1-b638-4136-970d-7871d2eeffa0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "135d1557-8797-43f0-a0c8-efc873846530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "878df552-46e2-4fdd-ae6e-b21c32d017ab",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "9bdaab35-c22e-430a-a756-84d69d7f084a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b84a619d-150f-45a6-be23-0080e3572762",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "320",
              },
              {
                _uid: "9f4dfcce-65a5-4cc6-9508-225e668ea9da",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "320",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "07b21b02-0f67-4a37-acba-d860060e9b21",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Note: Requirement 12.8 applies to all entities in this list.",
                placeholder: "",
                type: "",
                textareaRows: "2",
                col: "12",
                width: "100%",
                maxLength: "320",
                colSpan: "2",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 13
  {
    _uid: "1979dffb-311b-4c6b-a5bd-728b94f3a09a",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: ["Part 2. Executive Summary (continued)"],
    caption: "",
    simplifiedCaption: [],
    fields: [
      /* {
        _uid: "7ffdc48b-43c6-4c98-b0be-708567a854d1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "ccc08788-a53e-4573-b624-b94ea78b2736",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2g. Summary of Assessment",
                subBoldLabel: [
                  "(SAQ Section 2 and related appendices)",
                  "Indicate below all responses that were selected for each PCI DSS requirement.",
                ],
                type: "",
                width: "100%",
                col: "12",
              },
            ],
          },
        ],
      },
      {
        _uid: "28b86930-17c4-4d25-ab53-d3fccacec03d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: ["PCI DSS Requirement *", "", "", "Requirement Responses", ""],
        fields: [
          {
            fields: [
              {
                _uid: "4a042793-9fa8-40e4-a886-910b49be7f64",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "894c0e11-bdec-4d35-9c08-053a4e0892c5",
                component: "col",
                label: "",
                simplifiedLabel: "In Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2a5ef996-9789-4d82-9a7a-85b6ceea4edf",
                component: "col",
                label: "",
                simplifiedLabel: "In Place with CCW",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dd4bf0c5-bcc7-4fa5-8ffa-916c69770fd5",
                component: "col",
                label: "",
                simplifiedLabel: "Not Applicable",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "35d88a10-345f-4474-9c5a-d36b8f4164a0",
                component: "col",
                label: "",
                simplifiedLabel: "Not in Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be7e92ae-e202-4df9-8340-8c8e38738fdd",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 2:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "83483870-440a-4692-87c0-bd4b452cc5e6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3f957dfe-807a-44ea-9d07-5341d0c04327",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "99b311d0-504d-4835-a4e6-d918a461561c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3320a5b6-414d-4d2d-8cf2-38a54f01a264",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a89de058-db5e-4a7d-907f-340c6cc5b873",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 3:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d74498b3-96f3-4ea3-9bd2-8a054d8fc876",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2b03a47c-d91f-4853-92f9-5e7e80fcc6d0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e94cee9b-0a6f-4677-ae95-4f69775b638d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f763fa5e-8e3e-4058-9a34-088057f216dd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b4d424b9-913d-4c37-a468-8b7f57d705d1",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 6:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a19bb29e-d722-4863-90d0-3c486cb85118",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "68e7f630-a0b1-491c-89a2-f6115f3e3316",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "859de499-676f-4ddd-84ff-bbd282d3d616",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "07299892-5bf3-480d-888f-8cdb4f097f7e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8e249f70-e94c-4fea-a0d8-2ef0f4e3a168",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 8:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6785db61-e5fa-4ee6-a999-0b77dd7c2492",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "7b7a9017-5ad1-4e63-b999-9f32b48a8e54",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "cee30fd0-06b2-4e5e-9df5-27eb3ded7f74",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c47fbe40-d723-41ff-a616-2dd335369c08",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "afc55d56-558c-4972-999c-647b52b319c0",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 9:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "112fdc6c-d2ba-4884-be04-8ffd5eccafb5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c0700179-ddd9-413c-a9f0-9bdc04b00108",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "3d1bdb4f-532a-4b89-94ed-1af2c997b866",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "bffb79f6-dbb8-4f1b-8ac5-0f2bb32d5210",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1c4e1fa-d2ef-4eec-aa61-93d01419b8b5",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 11:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d985904e-543b-46c5-abf3-496c389a0c67",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6ea5fa98-f6cd-4e59-9758-91fc6d703c82",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "526b27a9-f398-4940-96e2-37afe1393309",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "eeee435a-0da8-4611-af63-6cc6367af20b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "56c7306a-4cbb-46ab-8f21-c84926a5ffff",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 12:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fca7f4a9-f065-4f18-a367-130e62dc1e04",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fb698b06-b4a8-4614-bc58-8357e5c2dad6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place_with_ccw",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e863bdc1-4d51-449e-ba9b-f8cfa68f7b07",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_na",
                col: "12",
                width: "20%",
              },
              {
                _uid: "20e88de4-ff63-491d-9422-d1db9a480d77",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_not_in_place",
                col: "12",
                width: "20%",
              },
            ],
          },
        ],
      }, */
      {
        _uid: "8ed72c89-084c-4630-a396-4c37d34e7550",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        fields: [
          {
            fields: [
              {
                _uid: "48174c70-534d-4286-97a4-09fe65326e98",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2h. Eligibility to Complete SAQ A",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a6b34cdb-23f7-4200-9c33-82e74843690b",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Merchant certifies eligibility to complete this Self-Assessment Questionnaire because, for this payment channel:",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "24dd15f3-a29c-4234-bcff-6ff3a1dbff59",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "a6b34cdb-23f7-4200-9c33-82e74843690b",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The merchant accepts only card-not-present (e-commerce or mail/telephone-order) transaction.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "81f1895d-249d-41d6-9deb-0453906ec813",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "51da8a41-09b8-402d-8148-d3eb658fbc04",
                component: "col",
                label: "",
                simplifiedLabel:
                  "All processing of account data is entirely outsourced to a PCI DSS compliant third-party service provider (TPSP)/payment processor.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2b4bd876-c731-480b-ba55-15162a61a806",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "da898916-e1a0-448d-951f-8d8723aaaadf",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The merchant does not electronically store, process, or transmit any account data on merchant systems or premises, but relies entirely on a TPSP(s) to handle all these functions.",
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f47414b-7eb2-4988-9d26-f34ae2234afe",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "90bd450d-aec4-4b7b-bd26-5e80662c72b3",
                component: "col",
                label: "",
                simplifiedLabel:
                  "The merchant has reviewed the PCI DSS Attestation of Compliance form(s) for its TPSP(s) and confirmed that TPSP(s) are PCI DSS compliant for the services being used by the merchant.",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c71a61a-9ebd-42aa-8bb8-f8506ce6d085",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "9c73bce1-511b-4055-814f-a5602ef37148",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Any account data the merchant might retain is on paper (for example, printed reports or receipts), and these documents are not received electronically.",
                width: "90%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "41322a08-54f4-4445-899d-bfd8e87c239a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "checkbox",
                value: "yes",
                type: "checkbox",
                width: "10%",
                col: "12",
              },
              {
                _uid: "b6bd2d07-3d30-4747-b0fb-43c939b11064",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Additionally, for e-commerce channels: ",
                  "All elements of the payment page(s)/form(s) delivered to the customer’s browser originate only and directly from a PCI DSS compliant TPSP/payment processor.",
                ],
                width: "90%",
                col: "12",
                hasLi: "no",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 14 - 31
  {
    _uid: "f239cdfc-6976-4ab0-8155-9e0af1f9e8e7",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Section 2: Self-Assessment Questionnaire A",
    caption: "",
    simplifiedCaption: [
      "Build and Maintain a Secure Network and Systems",
      "Requirement 2: Apply Secure Configurations to All System Components",
      "Note: The following requirements mirror the requirements in the PCI DSS Requirements and Testing Procedures document.",
    ],
    fields: [
      {
        _uid: "e5988b84-e67e-46f2-a1bd-7dd082524f62",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: [
          "",
          "PCI DSS Requirement",
          "Expected Testing",
          "Response (Check one response for each question)",
        ],
        fields: [
          // 14
          {
            fields: [
              {
                _uid: "3b5ca71f-e339-4c63-9426-3973a292a5d3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "65%",
                colSpan: 3,
              },
              {
                _uid: "c05aa970-2112-450b-bdad-d542eaa88dd6",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "select",
                options: [
                  {
                    value: "in_place",
                    label: "In Place",
                  },
                  {
                    value: "in_palce_with_CCW",
                    label: "In Place with CCW",
                  },
                  {
                    value: "na",
                    label: "Not Applicable",
                  },
                  {
                    value: "not_in_place",
                    label: "Not in Place",
                  },
                ],
                col: "12",
                width: "35%",
                colSpan: 2,
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6ad6fdf2-0108-44a7-a918-4887a6d799d9",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "2.2 System components are configured and managed securely",
                  "Note: For SAQ A, Requirement 2.2.2 applies to e-commerce merchants’ vendor default accounts on web servers.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b0a7d632-4606-4f25-8f56-e43beaf0e32d",
                component: "col",
                label: "",
                simplifiedLabel: "2.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3536f837-4c81-4c84-b27d-559cca72ba50",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Vendor default accounts are managed as follows:",
                  "If the vendor default account(s) will be used, the default password is changed per Requirement 8.3.6.",
                  "If the vendor default account(s) will not be used, the account is removed or disabled.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "55a03abf-69ac-4813-8b22-4817d8b31dd3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system configuration standards.",
                  "Examine vendor documentation.",
                  "Observe a system administrator logging on using vendor default accounts.",
                  "Examine configuration files.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "2ced54de-5b80-4f48-8f4b-4e4e72861154",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["25d7650f-ccf2-4af6-9a73-18a1f2974d35"],
                },
              },
              {
                _uid: "25d7650f-ccf2-4af6-9a73-18a1f2974d35",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                conditional: {
                  value: "na",
                  field:
                    "4605b800-5271-44a2-a442-a97b6ef71fd7_2ced54de-5b80-4f48-8f4b-4e4e72861154",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2dc183d4-76b0-41b9-8e3e-bdd6072cd776",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This applies to ALL vendor default accounts and passwords, including, but not limited to, those used by operating systems, software that provides security services, application and system accounts, point-of-sale (POS) terminals, payment applications, and Simple Network Management Protocol (SNMP) defaults.",
                  "This requirement also applies where a system component is not installed within an entity’s environment, for example, software and applications that are part of the CDE and are accessed via a cloud subscription service.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 15
          {
            fields: [
              {
                _uid: "13a7b01d-93d4-4e63-a658-75711d55cb20",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Note: For SAQ A, Requirement 3 applies only to merchants with paper records that include account data (for example, receipts or printed reports)",
                  "3.1 Processes and mechanisms for protecting stored account data are defined and understood.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "aa8978a1-43d0-4ae6-b1e0-bf3958f39568",
                component: "col",
                label: "",
                simplifiedLabel: "3.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "38aaf92a-fbc8-492c-a298-6ca4499deebf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All security policies and operational procedures that are identified in Requirement 3 are:",
                  "Documented",
                  "Kept up to date.",
                  "In use.",
                  "Known to all affected parties.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "506bae8e-f2c2-42ae-b9a5-06bb2764dc7d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  " Examine documentation.",
                  "Interview personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "e23446ac-19c4-400a-b0c2-4db5aabf4883",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["ad89e3b1-280a-49e7-8cb1-2236289caa4e"],
                },
              },
              {
                _uid: "ad89e3b1-280a-49e7-8cb1-2236289caa4e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4b6f145b-92ab-42d2-b2b9-e15b6a7d8080_e23446ac-19c4-400a-b0c2-4db5aabf4883",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "75d01791-ac6c-4c84-904f-68f3df0ddcdc",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 3.1.1 means that, if the merchant has paper storage of account data, the merchant has policies and procedures in place that govern merchant activities for Requirement 3. This helps to ensure personnel are aware of and following security policies and documented operational procedures for managing the secure storage of any paper records with account data.",
                  "If merchant does not store paper records with account data, mark this requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 16
          {
            fields: [
              {
                _uid: "8b27afe4-7d62-4beb-9a5b-69ec76f8edc5",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "3.2 Storage of account data is kept to a minimum.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "560ea4a6-6e4d-46db-9bc4-1d02975a46eb",
                component: "col",
                label: "",
                simplifiedLabel: "3.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5ec314eb-4a33-4b66-ab00-c4277f258484",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Account data storage is kept to a minimum through implementation of data retention and disposal policies, procedures, and processes that include at least the following:",
                  "Coverage for all locations of stored account data.",
                  "Coverage for any sensitive authentication data (SAD) stored prior to completion of authorization. This bullet is a best practice until its effective date; refer to Applicability Notes below for details.",
                  "Limiting data storage amount and retention time to that which is required for legal or regulatory, and/or business requirements.",
                  "Specific retention requirements for stored account data that defines length of retention period and includes a documented business justification.",
                  "Processes for secure deletion or rendering account data unrecoverable when no longer needed per the retention policy.",
                  "A process for verifying, at least once every three months, that stored account data exceeding the defined retention period has been securely deleted or rendered unrecoverable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "215d43fb-0f77-4135-a372-58f24dbbb481",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the data retention and disposal policies, procedures, and processes.",
                  "Interview personnel.",
                  "Examine files and system records on system components where account data is stored.",
                  "Observe the mechanisms used to render account data unrecoverable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6bba1b81-d646-4b99-9b48-be90fd1e5123",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["3f817ad3-5912-477d-8eec-75a360ee5f5b"],
                },
              },
              {
                _uid: "3f817ad3-5912-477d-8eec-75a360ee5f5b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "3e3118e7-1845-4a5b-b47e-ab74a1804690_6bba1b81-d646-4b99-9b48-be90fd1e5123",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b54dab54-8335-4796-b0a3-8cd42951faa0",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "Where account data is stored by a TPSP (for example, in a cloud environment), entities are responsible for working with their service providers to understand how the TPSP meets this requirement for the entity. Considerations include ensuring that all geographic instances of a data element are securely deleted.",
                  "The bullet above (for coverage of SAD stored prior to completion of authorization) is a best practice until 31 March 2025, after which it will be required as part of Requirement 3.2.1 and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 17
          {
            fields: [
              {
                _uid: "a9fb669f-0e0f-4b15-a04c-83c039fbe25b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 3.2.1 means that if a merchant stores any paper (for example, receipts or paper reports) that contain account data, the merchant only stores the paper as long as it is needed for business, legal, and/or regulatory reasons and destroys the paper once it is no longer needed.",
                  "If a merchant never prints or stores any paper containing account data, mark this requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 18
          {
            fields: [
              {
                _uid: "12da06ab-9d37-48cf-846f-89f68728e271",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Maintain a Vulnerability Management Program",
                  "Requirement 6: Develop and Maintain Secure Systems and Software",
                  "Note: For SAQ A, Requirement 6 applies to web servers that host the page(s) on the merchant’s website(s) that provide the address (the URL) of the TPSP’s payment page/form to the merchant’s customers.",
                  "6.3 Security vulnerabilities are identified and addressed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7a553f38-167f-40c9-851d-4c95e0589ab1",
                component: "col",
                label: "",
                simplifiedLabel: "6.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "c1117aa8-39b4-4e8d-813f-5aed71cd19ae",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Security vulnerabilities are identified and managed as follows:",
                  "New security vulnerabilities are identified using industry-recognized sources for security vulnerability information, including alerts from international and national computer emergency response teams (CERTs)",
                  "Vulnerabilities are assigned a risk ranking based on industry best practices and consideration of potential impact.",
                  "Risk rankings identify, at a minimum, all vulnerabilities considered to be a high-risk or critical to the environment.",
                  "Bullet intentionally left blank for this SAQ.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7dcbb581-e368-43ff-ae19-c1daff542348",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures",
                  "Interview responsible personnel.",
                  "Examine documentation.",
                  "Observe processes.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ec674070-83a0-4b78-bba5-81e3181a98db",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["b6c4dcc2-eca7-4d71-9140-30fd51c51437"],
                },
              },
              {
                _uid: "b6c4dcc2-eca7-4d71-9140-30fd51c51437",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "54fe3bca-5e7f-4eff-a678-2f0a1f2a4292_ec674070-83a0-4b78-bba5-81e3181a98db",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e74bf7b4-87a6-4784-a3a4-f534905c4623",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not achieved by, nor is it the same as, vulnerability scans performed for Requirements 11.3.1 and 11.3.2. This requirement is for a process to actively monitor industry sources for vulnerability information and for the entity to determine the risk ranking to be associated with each vulnerability.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 19
          {
            fields: [
              {
                _uid: "e869cd09-3289-4ece-8f2c-50a91babb8f7",
                component: "col",
                label: "",
                simplifiedLabel: "6.3.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "a918fb51-9dc6-4f7e-94a6-b205be8771fc",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All system components are protected from known vulnerabilities by installing applicable security patches/updates as follows:",
                  "Critical or high-security patches/updates are installed within one month of release.",
                  "Bullet intentionally left blank for this SAQ.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "047f88e2-a726-4ab4-8025-37ee9788c4c2",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures",
                  "Examine system components and related software.",
                  "Compare list of security patches installed to recent vendor patch lists.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["1d980035-33ce-4dba-a148-760180419abd"],
                },
              },
              {
                _uid: "1d980035-33ce-4dba-a148-760180419abd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "085d8b7f-ade1-4389-8d44-c528a96965ba_4d7772bb-b114-4f5d-8a59-7a10522f9edb",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ecb56b59-1ecb-4f95-9c30-8495a51c241e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "6.4 Public-facing web applications are protected against attacks",
                  "Note: For SAQ A, Requirement 6.4.3 applies to a merchant’s website(s) that includes a TPSP’s/payment processor’s embedded payment page/form (for example, an inline frame or iFrame).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "10220719-8581-4652-b0e1-153eaffc8154",
                component: "col",
                label: "",
                simplifiedLabel: "6.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "16892fdf-04cd-448e-a84b-8d383e5e0bff",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "All payment page scripts that are loaded and executed in the consumer’s browser are managed as follows:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dcbd443b-f2a8-4253-86f6-1524ae1e6767",
                component: "col",
                label: "",
                simplifiedLabel: "6.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1fcc2fea-ba6b-4623-ae51-10b8d4745316",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A method is implemented to confirm that each script is authorized.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "d71bc8c2-6c41-4cd4-93d1-0d69c7e56fe2",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the data retention and disposal policies, procedures, and processes.",
                  "Interview personnel.",
                  "Examine files and system records on system components where account data is stored.",
                  "Observe the mechanisms used to render account data unrecoverable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f924b88d-68af-4408-bcb3-c172f281d11b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["b4b7987d-20a2-4990-b3df-4fb2325a9748"],
                },
              },
              {
                _uid: "b4b7987d-20a2-4990-b3df-4fb2325a9748",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "3601bae6-2439-4c3e-a180-358dc68973b1_f924b88d-68af-4408-bcb3-c172f281d11b",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b4e1bf8f-adb1-481d-8fe0-af3b34fbb7de",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "43ab50e6-06ab-4df5-91b2-872e12a68acf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A method is implemented to assure the integrity of each script.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "bf5b5574-271f-4979-861e-ccfd25bd1a92",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the data retention and disposal policies, procedures, and processes.",
                  "Interview personnel.",
                  "Examine files and system records on system components where account data is stored.",
                  "Observe the mechanisms used to render account data unrecoverable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "0bd82c76-f93d-46ba-9387-7b82a21783fc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["8bc63c9c-a8b4-4994-b26f-80da694a7270"],
                },
              },
              {
                _uid: "8bc63c9c-a8b4-4994-b26f-80da694a7270",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "24892712-fc5a-41c1-bd57-0e7dd9945bf3_0bd82c76-f93d-46ba-9387-7b82a21783fc",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5c4a0575-581c-481d-9716-7d33f4190eb2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f67729dc-f624-4377-ac71-fd3d99607849",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An inventory of all scripts is maintained with written justification as to why each is necessary.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "fc427a4d-4f0d-484d-b64f-c387c743acc1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the data retention and disposal policies, procedures, and processes.",
                  "Interview personnel.",
                  "Examine files and system records on system components where account data is stored.",
                  "Observe the mechanisms used to render account data unrecoverable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["b90af7dd-93f0-408e-9a94-e75aaf7973fd"],
                },
              },
              {
                _uid: "b90af7dd-93f0-408e-9a94-e75aaf7973fd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "50d32aae-1a79-404a-984d-ad5873c3c2a2_f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4442f0e5-1236-4178-babf-9864b35e705e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement applies to all scripts loaded from the entity’s environment and scripts loaded from third and fourth parties.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 20
          {
            fields: [
              {
                _uid: "8d6498d8-2cdd-4d8c-bf5a-154fc255988b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Implement Strong Access Control Measures ",
                  "Requirement 8: Identify Users and Authenticate Access to System Components",
                  "Note: For SAQ A, Requirement 8 applies to merchant web servers that host the page(s) that either 1) redirects customers from the merchant website to a TPSP/payment processor for payment processing (for example, with a URL redirect) or 2) includes a TPSP’s/payment processor’s embedded payment page/form (for example, an inline frame or iFrame).",
                  "8.2 User identification and related accounts for users and administrators are strictly managed throughout an account’s lifecycle.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "59cc92ec-d73a-4bec-ad3e-fbc7231e57ff",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f19a517e-1312-4c0d-a813-dd905d58fcde",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All users are assigned a unique ID before access to system components or cardholder data is allowed.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ec116060-df10-41ce-bd38-cc7add5e057d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Interview responsible personnel",
                  "Examine audit logs and other evidence.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "697b2020-5b53-41ad-8833-10ca32041cc7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["a493012a-ddda-48d0-b0f2-c17c9b356147"],
                },
              },
              {
                _uid: "a493012a-ddda-48d0-b0f2-c17c9b356147",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "4bb007ce-1574-4125-bced-4783d3f150f7_697b2020-5b53-41ad-8833-10ca32041cc7",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1ebe5fab-3375-4a80-bafb-efe25f0d350b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 21
          {
            fields: [
              {
                _uid: "ea1f1537-ac35-4346-84ba-3b4337d9903e",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1fef28b4-fac7-4574-8e90-f384c22c77a4",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Group, shared, or generic accounts, or other shared authentication credentials are only used when necessary on an exception basis, and are managed as follows:",
                  "Account use is prevented unless needed for an exceptional circumstance.",
                  "Use is limited to the time needed for the exceptional circumstance.",
                  "Business justification for use is documented.",
                  "Use is explicitly approved by management.",
                  "Individual user identity is confirmed before access to an account is granted.",
                  "Every action taken is attributable to an individual user.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "edd8b309-883f-4fd5-b055-a3e2062d4432",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine user account lists on system components and applicable documentation.",
                  "Examine authentication policies and procedures.",
                  "Interview system administrators.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d0c21492-395c-4ebc-906a-90aa3b4751df",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["fff8c025-dc66-4447-846d-4a796d2298a6"],
                },
              },
              {
                _uid: "fff8c025-dc66-4447-846d-4a796d2298a6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "894ab185-0398-41bd-b828-456fdf382749_d0c21492-395c-4ebc-906a-90aa3b4751df",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2cbf1a8f-1e16-4398-aa05-c9068f98ff55",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4fe2c236-efc9-4485-901b-1ce33417ed87",
                component: "col",
                label: "",
                simplifiedLabel: "8.2.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7dc341e0-d63e-4ec4-88e5-0db780347f19",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Access for terminated users is immediately revoked.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "f5c7394d-c143-4918-abcc-fc9713682e4b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine information sources for terminated users.",
                  "Review current user access lists.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "9590a764-ff2d-40c2-a416-6a2b1927808e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["828dd2e4-a894-4acb-b5dc-26bd0203e154"],
                },
              },
              {
                _uid: "828dd2e4-a894-4acb-b5dc-26bd0203e154",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a76c5f10-b2ff-459b-bb5f-8fe16d4e9fdd_9590a764-ff2d-40c2-a416-6a2b1927808e",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0c2404bf-0348-4a02-b4eb-17751056ba12",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "8.3 Strong authentication for users and administrators is established and managed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4d891bb2-645b-4c34-b0c5-5d56e263e8b7",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "e6a6ac6a-08d3-476c-ad1b-72b7085f7300",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All user access to system components for users and administrators is authenticated via at least one of the following authentication factors:",
                  "Something you know, such as a password or passphrase.",
                  "Something you have, such as a token device or smart card.",
                  "Something you are, such as a biometric element.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "598e6f6d-0a31-4bda-a2b5-7069dc5ec230",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documentation describing the authentication factor(s) used.",
                  "For each type of authentication factor used with each type of system component, observe the authentication process.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["966b5fe7-d69f-45a8-b75e-1ce490e1e5d3"],
                },
              },
              {
                _uid: "966b5fe7-d69f-45a8-b75e-1ce490e1e5d3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "db67e93b-5a5b-47e5-bfe3-afad41425063_c24e59ab-bd97-41f3-b931-8f67fd77ed20",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f6f6c1d8-82db-4db2-8fce-14d252a19e6e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                  "This requirement does not supersede multi-factor authentication (MFA) requirements but applies to those in-scope systems not otherwise subject to MFA requirements.",
                  "A digital certificate is a valid option for “something you have” if it is unique for a particular user.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 22
          {
            fields: [
              {
                _uid: "216d3f23-7b61-4859-bc2e-e8e57d8daef4",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "1d8fa345-59fa-4a65-af73-9202c37d399b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If passwords/passphrases are used as authentication factors to meet Requirement 8.3.1, they are set and reset for each user as follows:",
                  "Set to a unique value for first-time use and upon reset.",
                  "Forced to be changed immediately after the first use.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7ee884c2-e85f-4b86-8c43-1602586cbac1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine procedures for setting and resetting passwords/passphrases.",
                  "Observe security personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["5203277d-bb88-4a4d-a747-bcae4ab04ae3"],
                },
              },
              {
                _uid: "5203277d-bb88-4a4d-a747-bcae4ab04ae3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "53dee0b2-bf62-4b05-8f9d-e843efd62e5c_32b9e151-ac03-405e-b1b7-3ac1593c64cc",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bd78a6dc-5a65-4a74-9662-c8eb980364cd",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7c03cf66-6a9a-46d6-8417-071256cd3f12",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If passwords/passphrases are used as authentication factors to meet Requirement 8.3.1, they meet the following minimum level of complexity:",
                  "A minimum length of 12 characters (or IF the system does not support 12 characters, a minimum length of eight characters).",
                  "Contain both numeric and alphabetic characters.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c44255b1-3760-4dc0-b00a-03c555048c72",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "69868741-8916-44b5-987d-ff409346bbc6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["3e9d1ad8-5d11-4647-b9d0-7ec663c55802"],
                },
              },
              {
                _uid: "3e9d1ad8-5d11-4647-b9d0-7ec663c55802",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "c310118e-25a8-41c7-b38d-3c440b3151f8_69868741-8916-44b5-987d-ff409346bbc6",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ac039ae5-6c62-4641-84f2-f9b0724cec4e",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to:",
                  "User accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals)",
                  "Application or system accounts, which are governed by requirements in section 8.6.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                  "Until 31 March 2025, passwords must be a minimum length of seven characters in accordance with PCI DSS v3.2.1 Requirement 8.2.3.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b01174cf-cdee-49d1-9502-b695c0c0f804",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.7",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2f34005a-f311-4ddf-9420-780c17a567d0",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Individuals are not allowed to submit a new password/passphrase that is the same as any of the last four passwords/passphrases used.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c5b7fdc0-2d8b-480f-bcfd-723862f27c81",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine system configuration settings"],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b3247b69-da29-4cfe-82f9-af09212d724f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["f1d906fe-3cb1-48ef-b8fb-2cbdb11b9ceb"],
                },
              },
              {
                _uid: "f1d906fe-3cb1-48ef-b8fb-2cbdb11b9ceb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8b0ef447-e9b0-4445-89bc-a807e78abd31_b3247b69-da29-4cfe-82f9-af09212d724f",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a5bf8266-4b6f-47c7-b60b-fe8540c91c90",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 23
          {
            fields: [
              {
                _uid: "66cab423-4b8e-4dbc-92ab-f6df88a22a7b",
                component: "col",
                label: "",
                simplifiedLabel: "8.3.9",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "d74788a1-32c6-4e57-9488-d6fb5318f2c4",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If passwords/passphrases are used as the only authentication factor for user access (i.e., in any singlefactor authentication implementation) then either:",
                  "Passwords/passphrases are changed at least once every 90 days,",
                  "OR",
                  "The security posture of accounts is dynamically analyzed, and real-time access to resources is automatically determined accordingly.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "95fd771c-9321-45ed-ae12-cf92b6a27295",
                component: "col",
                label: [],
                simplifiedLabel: ["Inspect system configuration settings."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c04e9d48-f2e3-4667-b836-d76b09697fb1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["678c3c00-a2b8-48cb-bbc0-427d82b8f135"],
                },
              },
              {
                _uid: "678c3c00-a2b8-48cb-bbc0-427d82b8f135",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "7eee08b0-4539-40b5-851b-3dce6d7e6ce5_c04e9d48-f2e3-4667-b836-d76b09697fb1",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cd62d353-b5b8-4305-95bd-b8111d5193f6",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "This requirement applies to in-scope system components that are not in the CDE because these components are not subject to MFA requirements.",
                  "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                  "This requirement does not apply to service providers’ customer accounts but does apply to accounts for service provider personnel.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          //24
          {
            fields: [
              {
                _uid: "f11d6700-9682-4b75-8738-d7f365fbea84",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Requirement 9: Restrict Physical Access to Cardholder Data",
                  "9.4 Media with cardholder data is securely stored, accessed, distributed, and destroyed",
                  "Note: For SAQ A, Requirements at 9.4 only apply to merchants with paper records (for example, receipts or printed reports) with account data, including primary account numbers (PANs).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4c3f557d-062f-46f0-b03b-071e4ec85580",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "b4275cb6-d1a0-4aad-962a-81eca6797a3d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All media with cardholder data is physically secured.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "bf86bc8a-7749-4e06-b3e1-aafea66e3776",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine documentation."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "99cc17e4-17d7-4109-becc-9064d032bd9b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["6cbb57e7-95b1-4fd2-877d-295a8bef66b4"],
                },
              },
              {
                _uid: "6cbb57e7-95b1-4fd2-877d-295a8bef66b4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "84acaaf1-a5a5-4c3b-a749-f1d0c4c750df_99cc17e4-17d7-4109-becc-9064d032bd9b",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "23ffa6e0-e476-4657-8e49-f2cb57ad3160",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.1.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "15bea25a-dee9-49a4-a13a-43d4e8d15833",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Offline media backups with cardholder data are stored in a secure location.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "9787c557-3cb0-4c01-81d2-1815e4a4245a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Examine logs or other documentation.",
                  "Interview responsible personnel at the storge location(s).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["9d7c8138-1b5e-436d-b107-b32e3246e33f"],
                },
              },
              {
                _uid: "9d7c8138-1b5e-436d-b107-b32e3246e33f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "f58249c1-95b2-4dfd-92e4-bd8190dbc2d7_ccb7da28-a7dc-4d17-afca-538b5a2623d6",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f840cb7-20c4-425e-8d84-28d7cf3b05c2",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7566d8bd-dc01-4126-abf7-d1c65c394911",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "All media with cardholder data is classified in accordance with the sensitivity of the data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c8763cdf-8c1f-44ea-9947-326b82f4c5bf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Examine media logs or other documentation.",
                  "Examine files and system records on system components where account data is stored.",
                  "Observe the mechanisms used to render account data unrecoverable.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["2d4d4c83-1815-47a0-9e97-16d70558c192"],
                },
              },
              {
                _uid: "2d4d4c83-1815-47a0-9e97-16d70558c192",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "a4cc0dfa-947a-425b-b79b-329e6ce3ddce_e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be442b22-f06d-405e-8dec-431533521ca2",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "7f9c3bb5-a30d-4d00-95c5-ebdfea7dddc8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Media with cardholder data sent outside the facility is secured as follows:",
                  "Bullet intentionally left blank for this SAQ",
                  "Media is sent by secured courier or other delivery method that can be accurately tracked.",
                  "Bullet intentionally left blank for this SAQ.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b34e6135-e337-450c-ae2c-ea043cb8ae9d",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Interview personnel.",
                  "Examine records.",
                  "Examine offsite tracking logs for all media.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dd7593a7-d618-429a-b464-025e2535c248",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["bfa73c2f-7001-4c55-982d-f29f494d0969"],
                },
              },
              {
                _uid: "bfa73c2f-7001-4c55-982d-f29f494d0969",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "87e5202e-67ab-49b9-9f35-c3057fd67214_dd7593a7-d618-429a-b464-025e2535c248",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "81a4691f-6a9f-4633-a177-94fe569d4b93",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "363845f6-6128-48e8-87ef-782991eacedd",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Management approves all media with cardholder data that is moved outside the facility (including when media is distributed to individuals)",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "94bbd7bf-cbe3-47a7-9894-8a3d47750e93",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine documented procedures",
                  "Examine offsite media tracking logs.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["45a9876d-77c4-4520-9ca1-9acbbc1101cb"],
                },
              },
              {
                _uid: "45a9876d-77c4-4520-9ca1-9acbbc1101cb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "186b4b62-0497-4eab-bbc7-6958249fc430_948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cddc0d95-b2b5-4e47-b4ea-88b36ea362bb",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "Individuals approving media movements should have the appropriate level of management authority to grant this approval. However, it is not specifically required that such individuals have “manager” as part of their title.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 25
          {
            fields: [
              {
                _uid: "649db51c-4b88-4c99-9a3c-874bedd87a52",
                component: "col",
                label: "",
                simplifiedLabel: "9.4.6",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "2b90d8e7-6f69-4347-91bc-eede1b1de2ea",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Hard-copy materials with cardholder data are destroyed when no longer needed for business or legal reasons, as follows:",
                  "Materials are cross-cut shredded, incinerated, or pulped so that cardholder data cannot be reconstructed.",
                  "Materials are stored in secure storage containers prior to destruction.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "378422e9-6e23-4d6b-b78a-74f871487bbd",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the periodic media destruction policy",
                  "Observe processes.",
                  "Interview personnel.",
                  "Observe storage containers.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b23f3713-d931-41dc-a567-d0138d9850f7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["ded23702-84be-405b-9b6c-dcb71b207a98"],
                },
              },
              {
                _uid: "ded23702-84be-405b-9b6c-dcb71b207a98",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "facda98e-e5aa-4a6e-9a61-181fdd172c2f_b23f3713-d931-41dc-a567-d0138d9850f7",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9c669dfe-a5e0-417f-aafd-f7d568ffec31",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "These requirements for media destruction when that media is no longer needed for business or legal reasons are separate and distinct from PCI DSS Requirement 3.2.1, which is for securely deleting cardholder data when no longer needed per the entity’s cardholder data retention policies.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cbcb71ef-7f0c-4c64-a6b5-091aa7d994b6",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirements at 9.4 means that the merchant securely stores any paper media with account data, for example by storing the paper in a locked drawer, cabinet, or safe, and that the merchant destroys such paper when no longer needed for business purposes. This includes a written document or policy for employees, so they know how to secure paper with account data and how to destroy the paper when no longer needed.",
                  "If the merchant never stores any paper with account data, mark this requirement as Not Applicable and complete Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 26
          {
            fields: [
              {
                _uid: "c28e4b81-6637-40ec-b6e6-b1176596aa28",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Requirement 11: Test Security of Systems and Networks Regularly",
                  "Note: For SAQ A, Requirement 11 applies to merchant web servers that host the page(s) that either 1) redirects customers from the merchant website to a TPSP/payment processor for payment processing (for example, with a URL redirect) or 2) includes a TPSP’s/payment processor’s embedded payment page/form (for example, an inline frame or iFrame).",
                  "11.3 External and internal vulnerabilities are regularly identified, prioritized, and addressed.",
                  "",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7288bbf0-60d8-4a36-897b-735c94a66596",
                component: "col",
                label: "",
                simplifiedLabel: "11.3.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6e30624a-a7bb-4139-874d-8deb80b90c90",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "External vulnerability scans are performed as follows:",
                  "At least once every three months.",
                  "By PCI SSC Approved Scanning Vendor (ASV).",
                  "Vulnerabilities are resolved and ASV Program Guide requirements for a passing scan are met.",
                  "Rescans are performed as needed to confirm that vulnerabilities are resolved per the ASV Program Guide requirements for a passing scan.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "66875b2e-3fc8-4364-9498-8fb3bdff349a",
                component: "col",
                label: [],
                simplifiedLabel: ["Examine ASV scan reports."],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["d13ee76d-f01a-401d-9a22-b353542b8119"],
                },
              },
              {
                _uid: "d13ee76d-f01a-401d-9a22-b353542b8119",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "79b24d5b-165d-49e2-b5d5-2843dc948c35_e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7288bbf0-60d8-4a36-897b-735c94a66596",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "For initial PCI DSS compliance, it is not required that four passing scans be completed within 12 months if the assessor verifies: 1) the most recent scan result was a passing scan, 2) the entity has documented policies and procedures requiring scanning at least once every three months, and 3) vulnerabilities noted in the scan results have been corrected as shown in a re-scan(s).",
                  "However, for subsequent years after the initial PCI DSS assessment, passing scans at least every three months must have occurred.",
                  "ASV scanning tools can scan a vast array of network types and topologies. Any specifics about the target environment (for example, load balancers, third-party providers, ISPs, specific configurations, protocols in use, scan interference) should be worked out between the ASV and scan customer.",
                  "Refer to the ASV Program Guide published on the PCI SSC website for scan customer responsibilities, scan preparation, etc.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 27
          {
            fields: [
              {
                _uid: "0db7d5b7-8537-43e3-9746-1329ed95ff77",
                component: "col",
                label: "",
                simplifiedLabel: "11.3.2.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "deaa3d47-31a8-42b6-bd2a-70a8e248b539",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "External vulnerability scans are performed after any significant change as follows:",
                  "Vulnerabilities that are scored 4.0 or higher by the CVSS are resolved.",
                  "Rescans are conducted as needed.",
                  "Scans are performed by qualified personnel and organizational independence of the tester exists (not required to be a QSA or ASV).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0eca287e-74a1-46bd-80f7-4758b7a87737",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine change control documentation.",
                  "Interview personnel.",
                  "Examine external scan, and as applicable rescan reports.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["871dc2d0-3b04-422e-aaf6-25cb249636cb"],
                },
              },
              {
                _uid: "871dc2d0-3b04-422e-aaf6-25cb249636cb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "46c6eaf5-1768-453a-86db-64c76ef47dd7_36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          // 28
          {
            fields: [
              {
                _uid: "c5edbfa7-a539-4455-a9f6-10a7e035b533",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "11.6 Unauthorized changes on payment pages are detected and responded to.",
                  "Note: For SAQ A, Requirement 11.6.1 applies to a merchant’s website that includes a TPSP’s/payment processor’s embedded payment page/form (for example, an inline frame or iFrame).",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7010e03b-f91a-4a9d-bfdc-51f180d6cd2f",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "11.6.1 A change- and tamper-detection mechanism is deployed as follows:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bd2e4ed6-8baf-4137-b582-8a9125a409ad",
                component: "col",
                label: "",
                simplifiedLabel: "11.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "3a6f9a81-7311-4023-a5c6-9717ea556b5f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "To alert personnel to unauthorized modification (including indicators of compromise, changes, additions, and deletions) to the HTTP headers and the contents of payment pages as received by the consumer browser.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "0339f356-ac53-4799-a19e-161958c05180",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system settings and mechanism configuration settings",
                  "Examine monitored payment pages.",
                  "Examine results from monitoring activities.",
                  "Examine the mechanism configuration settings.",
                  "Examine configuration settings.",
                  "Interview responsible personnel.",
                  "If applicable, examine the targeted risk analysis.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "2b9c301c-7eb6-4af7-a60c-b52aa088adea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["f484ffa5-a6c4-429d-a4bd-80b65c2fe78d"],
                },
              },
              {
                _uid: "f484ffa5-a6c4-429d-a4bd-80b65c2fe78d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "878658f1-8a6e-41a6-9e6e-2e410f56b279_2b9c301c-7eb6-4af7-a60c-b52aa088adea",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3e953d63-39f8-4e3c-8c32-40ba638eb84e",
                component: "col",
                label: "",
                simplifiedLabel: "11.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "88ea6dad-f844-4514-aa9e-4a5dceab8909",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The mechanism is configured to evaluate the received HTTP header and payment page.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "dca1fc7c-ddb7-4bbc-aa63-3df5a28303cf",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system settings and mechanism configuration settings",
                  "Examine monitored payment pages.",
                  "Examine results from monitoring activities.",
                  "Examine the mechanism configuration settings.",
                  "Examine configuration settings.",
                  "Interview responsible personnel.",
                  "If applicable, examine the targeted risk analysis.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5c59e570-80fb-4a90-8c43-00733f977ec6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["85195eaa-409e-4649-bc74-ffe67418993a"],
                },
              },
              {
                _uid: "85195eaa-409e-4649-bc74-ffe67418993a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "e13caf05-7c8b-4340-83c0-ef69b512c75e_5c59e570-80fb-4a90-8c43-00733f977ec6",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6b5f5311-5974-4644-ba27-609674e6e887",
                component: "col",
                label: "",
                simplifiedLabel: "11.6.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "9a0d7f0a-34e4-481e-a964-513345507c8e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "The mechanism functions are performed as follows:",
                  "– At least once every seven days",
                  "OR",
                  "Periodically (at the frequency defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1).",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "34e7c444-90f2-42ff-b59c-a3c631cb7f55",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine system settings and mechanism configuration settings",
                  "Examine monitored payment pages.",
                  "Examine results from monitoring activities.",
                  "Examine the mechanism configuration settings.",
                  "Examine configuration settings.",
                  "Interview responsible personnel.",
                  "If applicable, examine the targeted risk analysis.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["c505a38c-31ae-4321-a550-02306a9c6192"],
                },
              },
              {
                _uid: "c505a38c-31ae-4321-a550-02306a9c6192",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "c22c32ac-804d-40a7-9f5a-3cba03726252_b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "670838b2-d194-4ab6-b14d-8487daf69d42",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The intention of this requirement is not that an entity installs software in the systems or browsers of its consumers, but rather that the entity uses techniques such as those described under Examples in the PCI DSS Guidance column (of PCI DSS Requirements and Testing Procedures) to prevent and detect unexpected script activities.",
                  "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "92d4ed82-4733-4cae-9c96-02f6a5643e73",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "If a merchant uses URL redirects, where the merchant hosts the page(s) on their website(s) that provides the address (the URL) of the TPSP’s/payment processor’s payment page/form to the merchant’s customers, the merchant marks this requirement as Not Applicable and completes Appendix C: Explanation of Requirements Noted as Not Applicable.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 29
          {
            fields: [
              {
                _uid: "6dd7b146-10e9-4d4f-9048-e9f77d80dd61",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Maintain an Information Security Policy ",
                  "Requirement 12: Support Information Security with Organizational Policies and Programs",
                  "Note: Requirement 12 specifies that merchants have information security policies for their personnel, but these policies can be as simple or complex as needed for the size and complexity of the merchant’s operations. The policy document must be provided to all personnel, so they are aware of their responsibilities for protecting payment terminals, any paper documents with account data, etc. If a merchant has no employees, then it is expected that the merchant understands and acknowledges their responsibility for security within their store(s).",
                  "12.8 Risk to information assets associated with third-party service provider (TPSP) relationships is managed.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "cc5339ec-0c9f-4993-8e81-356e1e3fd060",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "77750b12-f26e-4a06-8a86-60b23e7c0506",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A list of all third-party service providers (TPSPs) with which account data is shared or that could affect the security of account data is maintained, including a description for each of the services provided.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "49c99066-16d7-4180-af4c-5f4286ebce7b",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine list of TPSPs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6513c7da-3894-4c92-ba89-bf75834c1b21",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["33370b6f-8461-41d8-ad6d-3061f80a4103"],
                },
              },
              {
                _uid: "33370b6f-8461-41d8-ad6d-3061f80a4103",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8bb4cc1d-ae6b-4d26-b468-2c605db60a1b_6513c7da-3894-4c92-ba89-bf75834c1b21",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "30eee53d-e324-4335-b5d7-ef8e70b81e37",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The use of a PCI DSS compliant TPSP does not make an entity PCI DSS compliant, nor does it remove the entity’s responsibility for its own PCI DSS compliance.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 30
          {
            fields: [
              {
                _uid: "93c2b8d3-1684-47ad-9f1d-6c7f99d64797",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.2",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "0d26a7c8-27e5-49a5-b1ed-7b389ed75e1f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Written agreements with TPSPs are maintained as follows:",
                  "Written agreements are maintained with all TPSPs with which account data is shared or that could affect the security of the CDE.",
                  "Written agreements include acknowledgments from TPSPs that they are responsible for the security of account data the TPSPs possess or otherwise store, process, or transmit on behalf of the entity, or to the extent that they could impact the security of the entity’s CDE.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5598f7ca-0246-4e5e-9c78-d6a4d7c24123",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine written agreements with TPSPs.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "63fff20d-a022-42b9-8c16-bfec89f01384",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["172fb8df-2d5a-4fa8-9f2d-411e93dc6bd7"],
                },
              },
              {
                _uid: "172fb8df-2d5a-4fa8-9f2d-411e93dc6bd7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "3abb8bce-42fa-4b9b-b1fb-f2b092511beb_63fff20d-a022-42b9-8c16-bfec89f01384",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6de5cd7f-12c3-42a8-897c-2074683b3215",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "The exact wording of an acknowledgment will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgment does not have to include the exact wording provided in this requirement.",
                  "Evidence that a TPSP is meeting PCI DSS requirements (for example, a PCI DSS Attestation of Compliance (AOC) or a declaration on a company’s website) is not the same as a written agreement specified in this requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "13257d1f-e538-4fe9-92c2-91ab87cfaa6f",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.3",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "6ef366ed-51a1-4b28-b96c-4f269458a0cc",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An established process is implemented for engaging TPSPs, including proper due diligence prior to engagement.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "856d5de2-514c-42df-b12a-b212d63033f9",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine evidence.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c33690f2-0813-4a47-80f3-bc1fc453cb67",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["8159ad20-54db-4a0f-a16c-f82fa1910fd6"],
                },
              },
              {
                _uid: "8159ad20-54db-4a0f-a16c-f82fa1910fd6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "248c3931-0589-458e-9e59-81d1ca87c002_c33690f2-0813-4a47-80f3-bc1fc453cb67",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "50dbe4dd-86e6-4815-a3c7-1cc0c1842a55",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.4",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "f24d027b-b146-48ba-9509-364e8f9f3f1f",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "A program is implemented to monitor TPSPs’ PCI DSS compliance status at least once every 12 months.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "36952c44-2fbb-414f-90aa-193929fb7294",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine documentation.",
                  "Interview responsible personnel",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "384945ff-bca6-4ca0-948c-6168ceefda51",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["ebfcc76b-1a58-4965-bc53-d0e875f6bb82"],
                },
              },
              {
                _uid: "ebfcc76b-1a58-4965-bc53-d0e875f6bb82",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "54e0d5f9-af39-4778-94d3-b5af0b66e43a_384945ff-bca6-4ca0-948c-6168ceefda51",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "774c1f7d-7c04-486e-815c-56283c619f46",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Applicability Notes",
                  "Where an entity has an agreement with a TPSP for meeting PCI DSS requirements on behalf of the entity (for example, via a firewall service), the entity must work with the TPSP to make sure the applicable PCI DSS requirements are met. If the TPSP does not meet those applicable PCI DSS requirements, then those requirements are also “not in place” for the entity.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          // 31
          {
            fields: [
              {
                _uid: "47421d6e-80d9-4f9d-82a6-eed98c922da6",
                component: "col",
                label: "",
                simplifiedLabel: "12.8.5",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "27bcb2b1-4c35-4603-82cc-e20e710675a1",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Information is maintained about which PCI DSS requirements are managed by each TPSP, which are managed by the entity, and any that are shared between the TPSP and the entity.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "40b3b7e2-6a9c-448f-a1ab-1db76ac672c8",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine policies and procedures.",
                  "Examine documentation.",
                  "Interview responsible personnel.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "686e307f-e890-4567-8c1c-b945bdfd80f5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["4ccf9f6c-1fc1-4051-83b7-aef8743772a4"],
                },
              },
              {
                _uid: "4ccf9f6c-1fc1-4051-83b7-aef8743772a4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "5c6dc296-1ea5-4bc8-ba21-33b75cd4d804_686e307f-e890-4567-8c1c-b945bdfd80f5",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6e729e7c-a260-464a-b7b8-b2bfd8c387e8",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for requirements at 12.8.1 through 12.8.5 means that the merchant has a list of, and agreements with, service providers they share account data with or that could impact the security of the merchant’s cardholder data environment. For example, such agreements would be applicable if a merchant uses a document-retention company to store paper documents that include account data or if a merchant’s vendor accesses merchant systems remotely to perform maintenance.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ed1ce795-0360-48fe-9201-6b1c682853d2",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "12.10 Suspected and confirmed security incidents that could impact the CDE are responded to immediately",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "9cafc999-3882-4b03-8bae-b36313d53667",
                component: "col",
                label: "",
                simplifiedLabel: "12.10.1",
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "8f084807-7ff6-4659-9176-39e5792403a3",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "An incident response plan exists and is ready to be activated in the event of a suspected or confirmed security incident. The plan includes, but is not limited to:",
                  "Roles, responsibilities, and communication and contact strategies in the event of a suspected or confirmed security incident, including notification of payment brands and acquirers, at a minimum.",
                  "Incident response procedures with specific containment and mitigation activities for different types of incidents",
                  "Business recovery and continuity procedures.",
                  "Data backup processes",
                  "Analysis of legal requirements for reporting compromises.",
                  "Coverage and responses of all critical system components.",
                  "Reference or inclusion of incident response procedures from the payment brands.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "ed76e428-eaa9-4bbc-aa28-be7a31741ef7",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "Examine the incident response plan.",
                  "Interview personnel.",
                  "Examine documentation from previously reported incidents.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place",
                    value: "in_place",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "In Place with CCW",
                    value: "in_palce_with_CCW",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "N/A",
                    value: "na",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Not in Place",
                    value: "not_in_place",
                  },
                ],
                width: "40%",
                resetFields: {
                  value: ["in_place", "in_palce_with_CCW", "not_in_place"],
                  _uids: ["b6cd6b63-5105-4556-bfde-5e0f4ec5f21c"],
                },
              },
              {
                _uid: "b6cd6b63-5105-4556-bfde-5e0f4ec5f21c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "Please explain the reason of N/A",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                enabledOn: "na",
                conditional: {
                  value: "na",
                  field:
                    "8cd1e1f0-6783-410c-bc91-ebc5cafa0def_854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
                },
                width: "20%",
                maxLength: "245",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6c5c4f93-c07c-444d-9845-8a5d5b03e319",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "SAQ Completion Guidance:",
                  "Selection of any of the In Place responses for Requirement 12.10.1 means that the merchant has documented an incident response and escalation plan to be used for emergencies, consistent with the size and complexity of the merchant’s operations. For example, such a plan could be a simple document posted in the back office that lists who to call in the event of various situations with an annual review to confirm it is still accurate, but could extend all the way to a full incident response plan including backup “hotsite” facilities and thorough annual testing. This plan should be readily available to all personnel as a resource in an emergency",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 5,
                width: "100%",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 32 NA
  // Page 33
  {
    _uid: "dab5ee3f-880d-4aa2-9f08-457d4f3a9731",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Appendix B: Compensating Controls Worksheet",
    fields: [
      {
        _uid: "9daab1fd-0b33-4945-b3d1-0eee9eb91030",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "This Appendix must be completed to define compensating controls for any requirement where In Place with CCW was selected.",
          "Note: Only entities that have a legitimate and documented technological or business constraint can consider the use of compensating controls to achieve compliance",
          "Refer to Appendices B and C in PCI DSS for information about compensating controls and guidance on how to complete this worksheet.",
        ],
        headers: ["", "Information Required", "Explanation"],
        fields: [
          {
            fields: [
              {
                _uid: "de0a670f-733d-499c-aaf3-1809dd7d9ee1",
                component: "col",
                label: [""],
                simplifiedLabel: ["1. Constraints"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "945fb1ac-20f5-4fa4-aa84-fa2220e98ffd",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Document the legitimate technical or business constraints precluding compliance with the original requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "fb2239c6-fa8b-479f-879b-452a4b5dce51",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c9d2277-a966-49d2-bfe8-7a4da7021bbc",
                component: "col",
                label: [""],
                simplifiedLabel: ["2. Definition of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8664ee54-d714-4ff7-b14f-8fd1405e9fb6",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define the compensating controls: explain how they address the objectives of the original control and the increased risk, if any. ",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "7e1b04e8-df1d-4da2-8823-22aa1c320979",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "027ef055-9911-49d2-800a-00e0843df4a9",
                component: "col",
                label: [""],
                simplifiedLabel: ["3. Objective"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "dae5ee30-a548-40c8-aeef-e8d1395482f7",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define the objective of the original control.",
                ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ec8d9a96-5d17-44f2-83a5-e84ee8db369b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "228a69c9-4e4d-4f91-a8bd-0a5f004bf5ca",
                component: "col",
                label: [""],
                simplifiedLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "cd8d53c5-90c6-4ef3-946d-1ff2804a306d",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify the objective met by the compensating control.",
                  "Note: This can be, but is not required to be, the stated Customized Approach Objective listed for this requirement in PCI DSS.",
                ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "23386351-dfc0-4716-9e95-a109b2b9584d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "225",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d24ea8c5-8e3a-4169-9382-694d15de0095",
                component: "col",
                label: [""],
                simplifiedLabel: ["4. Identified Risk"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c65b215d-9473-4a3b-83fa-4f38e280a86c",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify any additional risk posed by the lack of the original control.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ac43edc2-cc76-4dab-a281-c0f4920e21d6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "85",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "95e41bd3-f17f-4913-8586-8ec91b525370",
                component: "col",
                label: [""],
                simplifiedLabel: ["5. Validation of Compensating Controls"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3385059a-2a84-4c17-8fa6-71415e4fd63f",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define how the compensating controls were validated and tested.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "275d5b08-cd5d-4fac-a9a7-dcedd56bbb45",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7579bd14-4a0e-45fe-96a2-580c3633c55e",
                component: "col",
                label: [""],
                simplifiedLabel: ["6. Maintenance"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ee1d386c-8f68-477a-8d0c-f21049dc48d1",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Define process(es) and controls in place to maintain compensating controls.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "f1b079bf-3df6-4939-891a-574c0fb4e583",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "6",
                maxLength: "125",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 34 - data inserted from radio na reason
  // Page 35 - NA
  // Page 36
  {
    _uid: "7e83a74e-5401-4afb-a7f8-102d9735de70",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Section 3: Validation and Attestation Details",
    fields: [
      {
        _uid: "c7270999-95f6-4d2e-a907-046872e56fd7",
        component: "table",
        label: "",
        simplifiedLabel: "Part 3. PCI DSS Validation",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "Part 3. PCI DSS Validation",
          "This AOC is based on results noted in SAQ A (Section 2), dated (Self-assessment completion date YYYY-MM-DD).",
          "Based on the results documented in the SAQ A noted above, each signatory identified in any of Parts 3b−3d, as applicable, assert(s) the following compliance status for the merchant identified in Part 2 of this document.",
          "Select one:",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "7c7cc5b3-ff97-4bc7-9298-bbf8da13e3d6",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "c8b0e1e8-e107-4932-83ec-80b74330a20a",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Compliant: All sections of the PCI DSS SAQ are complete and all requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1fcd7a57-9df1-4900-8925-e81fdb116f05",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "Compliant",
                width: "20%",
              },
              {
                _uid: "c266fb46-9282-4ad8-bd7c-112265d8503f",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Non-Compliant: Not all sections of the PCI DSS SAQ are complete, or one or more requirements are marked as Not in Place, resulting in an overall NON-COMPLIANT rating; thereby (Merchant Company Name) has not demonstrated compliance with the PCI DSS requirements included in this SAQ",
                  "Target Date for Compliance: YYYY-MM-DD",
                  "A merchant submitting this form with a Non-Compliant status may be required to complete the Action Plan in Part 4 of this document. Confirm with the entity to which this AOC will be submitted before completing Part 4.",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                component: "checkbox",
                type: "checkbox",
                value: "yes",
                width: "20%",
                col: "12",
                resetFields: {
                  value: "",
                  _uids: [
                    "ba5792dd-b17b-449e-b2aa-1c619eed20df",
                    "5006af3f-fcdc-4c04-a002-aa05456e3984",
                    "e6b79503-be2a-403f-8636-ca57d9f9c3bc",
                    "1f559e4b-02e3-4443-a846-837debacbd65",
                    "602ec636-86d6-4944-932b-ddd81d0b0b75",
                    "92df6dc3-c01f-4170-809b-ff5ea0f189c4",
                    "715bb739-794d-46f4-9e82-a6b909a5b326",
                    "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                  ],
                },
              },
              {
                _uid: "2439ba3c-a98f-4259-8ecd-4d574697c1fe",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Compliant but with Legal exception: One or more requirements in the PCI DSS SAQ are marked as Not in Place due to a legal restriction that prevents the requirement from being met and all other requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT BUT WITH LEGAL EXCEPTION rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ except those noted as Not in Place due to a legal restriction.",
                  "Target Date for Compliance: YYYY-MM-DD",
                  "This option requires additional review from the entity to which this AOC will be submitted. If selected, complete the following:",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ba5792dd-b17b-449e-b2aa-1c619eed20df",
                component: "label",
                label: "",
                simplifiedLabel: "Affected Requirement",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "11ab4969-da83-4b14-94ea-65ec33e4cfce_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                width: "50%",
              },
              {
                _uid: "5006af3f-fcdc-4c04-a002-aa05456e3984",
                component: "label",
                label: "",
                simplifiedLabel:
                  "Details of how legal constraint prevents requirement being met",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "1c2ed136-0cb6-47b7-a403-ebd93ca5a285_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e6b79503-be2a-403f-8636-ca57d9f9c3bc",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "65971a55-9857-4899-a784-c01abb0fa044_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "1f559e4b-02e3-4443-a846-837debacbd65",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "d5867ec6-cbf8-454e-b7b3-017ad7913a2c_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "602ec636-86d6-4944-932b-ddd81d0b0b75",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "3848c469-8c36-4bcd-9b87-9a32434151b4_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "92df6dc3-c01f-4170-809b-ff5ea0f189c4",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "698387bc-14c6-4005-859c-9da0c41dd5b8_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "715bb739-794d-46f4-9e82-a6b909a5b326",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "7333d173-4c53-4d4a-89a4-f9f556d8bd36_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field:
                    "60350b4b-15b4-4dc0-8a32-cfaf1afa3369_8a5b1bf7-3e34-4f5d-b349-468f80644ca7",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 37
  {
    _uid: "f7c40153-fe36-4570-82dd-520eae2fba93",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "",
    fields: [
      {
        _uid: "3703ad33-f778-4bd8-b560-3398cb1513bb",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "Part 3a. Merchant Acknowledgement",
          "Signatory(s) confirms:",
          "(Select all that apply)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "a63691e9-9567-4925-820d-8752abe6b612",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "ece6b93a-7d16-46da-8138-36ba3dc12eca",
                component: "col",
                label: "",
                simplifiedLabel:
                  "PCI DSS Self-Assessment Questionnaire A, Version 4.0, was completed according to the instructions therein.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "38e7ba32-6b9e-4fc0-9d61-88fcd54ac6f5",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "e1d37b77-af21-404a-b097-f590e080d2fb",
                component: "col",
                label: "",
                simplifiedLabel:
                  "All information within the above-referenced SAQ and in this attestation fairly represents the results of the merchant’s assessment in all material respects.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f7a669dc-9758-48d4-82b9-e6722b0c7702",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "e6471716-6d26-4d89-b774-02143b7dc6ed",
                component: "col",
                label: "",
                simplifiedLabel:
                  "PCI DSS controls will be maintained at all times, as applicable to the merchant’s environment.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
        ],
      },
      {
        _uid: "8f34029d-61d7-4367-aa3e-12f699040a34",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "Part 3b. Merchant Attestation",
        fields: [
          {
            fields: [
              {
                _uid: "3ef29462-9468-467a-8d33-668475e19187",
                component: "col",
                label: ["Signature of Merchant Executive Officer"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: "2",
                width: "60%",
              },
              {
                _uid: "b3e0e859-b26d-4b43-83fa-66ba717c8e2a",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "40%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b89c195b-c9b3-4ce2-b42e-8ada2e40452e",
                component: "col",
                label: [""],
                simplifiedLabel: ["Signature of Merchant Executive Officer"],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "60%",
              },
              {
                _uid: "faed680a-fdae-491b-8709-482415861e49",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: 2,
                width: "40%",
                maxLength: "28",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8ccbfc40-c74c-44c9-a7c9-c7a287f5541b",
                component: "col",
                label: [""],
                simplifiedLabel: ["Merchant Executive Officer Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "0089362f-b884-452d-9776-f263fdd3c854",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "30%",
                maxLength: "28",
              },
              {
                _uid: "14b71baa-67ec-487c-b3ad-550a01c8bae6",
                component: "col",
                label: [""],
                simplifiedLabel: ["Title"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "5%",
              },
              {
                _uid: "5b418f20-5a39-47cd-8461-547185b91a05",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "35%",
                maxLength: "28",
              },
            ],
          },
        ],
      },
      {
        _uid: "6d65f61b-3db3-4dc2-bbf6-7aab1f08d25c",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption:
          "Part 3c. Qualified Security Assessor (QSA)Acknowledgement",
        fields: [
          {
            fields: [
              {
                _uid: "2bec4c53-6aef-41d8-9742-f87afea4130a",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If a QSA was involved or assisted with this assessment, indicate the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "4",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "342c7f00-e529-4caa-b61b-eadc43297e95",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "bd573f0c-ea66-42be-8361-f5d544c925b6",
                component: "col",
                label: "",
                simplifiedLabel: "QSA performed testing procedures.",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f37d68dc-b295-4e6e-a257-d756f885ab53",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
                resetFields: {
                  value: "",
                  _uids: [
                    "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
                    "35f6ff12-551f-411c-9f09-5262a8bc9882",
                    "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
                    "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
                    "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
                    "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
                    "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
                    "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
                    "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
                    "af9fceed-d116-496d-abe6-e7364f54bc54",
                    "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
                    "a16d9f36-c251-418f-ae30-09a81476075c",
                    "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
                    "a3aa4592-abf0-446b-b9f4-2a254494befe",
                  ],
                },
              },
              {
                _uid: "ae4da7e1-24d5-4500-81ed-f48ec5fffe81",
                component: "col",
                label: "",
                simplifiedLabel:
                  "QSA provided other assistance. If selected, describe all role(s) performed:",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
                component: "col",
                label: ["Signature of Lead QSA"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "c52e2f18-f82c-4430-83af-7a1f504ec37a_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "35f6ff12-551f-411c-9f09-5262a8bc9882",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "d03ca81e-8fc0-40bb-8779-221afdca5777_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
                component: "col",
                label: [""],
                simplifiedLabel: ["Signature of Lead QSA"],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "618009f8-60f2-4b71-ae30-ccc32ff61f9d_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "2e9289f6-2dd2-4a57-951e-8922ce0d230f_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
                component: "col",
                label: [""],
                simplifiedLabel: ["Lead QSA Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "2",
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "f78aa84f-c10e-4245-90b3-8a77fa04bf48_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: "2",
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "24ff9345-8cde-42ef-bd4e-a9c8f08bd200_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
                component: "col",
                label: ["Signature of Duly Authorized Officer of QSA Company"],
                simplifiedLabel: [""],
                hasLi: "no",
                type: "text",
                col: "12",
                colSpan: 2,
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "d8b5ada2-e0bf-4c66-a7db-df659113c503_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
                component: "col",
                label: ["Date: YYYY-MM-DD"],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                colSpan: 2,
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "0081a7e9-4a50-4471-a122-1838914e2bc4_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Signature of Duly Authorized Officer of QSA Company",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 2,
                width: "50%",
                conditional: {
                  value: "yes",
                  field:
                    "0bf50a7d-1cae-437b-bc3b-d68d3ffbc2f0_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "af9fceed-d116-496d-abe6-e7364f54bc54",
                component: "col",
                label: [""],
                simplifiedLabel: ["Date: YYYY-MM-DD"],
                type: "",
                col: "12",
                colSpan: 2,
                width: "50%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "37e9409a-415a-4ab6-bcdc-e52e4f182d62_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
                component: "col",
                label: [""],
                simplifiedLabel: ["Duly Authorized Officer Name: "],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
                conditional: {
                  value: "yes",
                  field:
                    "0dd0847a-6c4d-4084-8b9d-589a11e48f33_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "a16d9f36-c251-418f-ae30-09a81476075c",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "25%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "635a5887-6188-4ce1-8cf1-077188312f19_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
                component: "col",
                label: [""],
                simplifiedLabel: ["QSA Company:"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
                conditional: {
                  value: "yes",
                  field:
                    "0c0ca787-57d6-42a0-ac0d-a21218e17384_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
              {
                _uid: "a3aa4592-abf0-446b-b9f4-2a254494befe",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                type: "text",
                col: "12",
                width: "30%",
                maxLength: "28",
                conditional: {
                  value: "yes",
                  field:
                    "a4c9e942-883a-4ddd-9657-a1b59cb7d73e_f37d68dc-b295-4e6e-a257-d756f885ab53",
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "7dcf3b0b-4a10-4ab7-ad8c-0444a9e88f7b",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption:
          "Part 3d. PCI SSC Internal Security Assessor (ISA) Involvement",
        fields: [
          {
            fields: [
              {
                _uid: "57354855-b0ab-4f2d-8fcb-2609c472678e",
                component: "col",
                label: [],
                simplifiedLabel: [
                  "If an ISA(s) was involved or assisted with this assessment, indicate the role performed:",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: "4",
                width: "100%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "88542f99-4c83-4291-b18d-282e2b0632ee",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "ecf60fad-172b-48b7-af42-55583f2a3171",
                component: "col",
                label: "",
                simplifiedLabel: "ISA(s) performed testing procedures.",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e2c67566-11eb-4f56-b495-8ea89f703fa9",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
                resetFields: {
                  value: "",
                  _uids: ["6bbfebb8-6022-4ccb-aa16-4249a6d38e02"],
                },
              },
              {
                _uid: "2462213e-afc6-4e28-9c7c-4d5cf4c2c54a",
                component: "col",
                label: "",
                simplifiedLabel:
                  "ISA(s) provided other assistance. If selected, describe all role(s) performed:",
                type: "",
                width: "80%",
                col: "12",
                colSpan: "3",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6bbfebb8-6022-4ccb-aa16-4249a6d38e02",
                component: "col",
                label: "",
                simplifiedLabel: "",
                placeholder: "Describe all role(s) performed",
                type: "textarea",
                textareaRows: "12",
                col: "12",
                colSpan: 4,
                conditional: {
                  value: "yes",
                  field:
                    "7a710f1f-871f-4e23-b074-c2c0389ab984_e2c67566-11eb-4f56-b495-8ea89f703fa9",
                },
                width: "100%",
                maxLength: "320",
              },
            ],
          },
        ],
      },
    ],
  },
  // Page 38
  {
    _uid: "6703f7b8-d620-4566-ba6b-57e9c2d3af2b",
    layout: "form",
    component: "page",
    label: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "ad8680c0-ba56-4145-83bc-f20850f511f5",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [""],
                simplifiedLabel: [""],
                boldLabel: "Part 4. Action Plan for Non-Compliant Requirements",
                subBoldLabel: [
                  "Only complete Part 4 upon request of the entity to which this AOC will be submitted, and only if the Assessment has a Non-Compliant status noted in Section 3.",
                  "If asked to complete this section, select the appropriate response for “Compliant to PCI DSS Requirements” for each requirement below. For any “No” responses, include the date the merchant expects to be compliant with the requirement and a brief description of the actions being taken to meet the requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
            ],
          },
        ],
      },
      {
        _uid: "afb88315-dfc5-483e-b1d6-d727d7d569d6",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: [
          "PCI DSS Requirement*",
          "Description of Requirement",
          "Compliant to PCI DSS Requirements",
          "Remediation Date and Actions (If “NO” selected for any Requirement)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [""],
                simplifiedLabel: ["2"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8fd97f10-d533-4004-a6ed-e4cad018e190",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Apply secure configurations to all system components",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3de2fb2a-abeb-4d2a-8480-638084717840",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["0d523bb5-d058-402f-8abb-7f05a1d77a8e"],
                },
              },
              {
                _uid: "0d523bb5-d058-402f-8abb-7f05a1d77a8e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                conditional: {
                  value: "no",
                  field:
                    "d9c63712-899e-4466-8e12-1fd267bff257_3de2fb2a-abeb-4d2a-8480-638084717840",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a799130-aef0-401e-8f88-a243cb56b628",
                component: "col",
                label: [""],
                simplifiedLabel: ["3"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7af99412-1790-49b0-80f3-8452bc7086d2",
                component: "col",
                label: [""],
                simplifiedLabel: ["Protect stored account data"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c03217d3-7e28-4aaa-96de-5d246e84b703",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["7a0eca31-d1df-4d1c-92c7-9841be86d4bc"],
                },
              },
              {
                _uid: "7a0eca31-d1df-4d1c-92c7-9841be86d4bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "35d5ab45-31a3-4480-98f8-f3965ac2e831_c03217d3-7e28-4aaa-96de-5d246e84b703",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7d909157-3e85-402c-afc9-9687534cc37e",
                component: "col",
                label: [""],
                simplifiedLabel: ["6"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5aab4319-f9df-4a5a-b2ea-5d6c94adc638",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Develop and maintain secure systems and software",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["d218a370-bedf-4c06-ab0c-c3593d20ef19"],
                },
              },
              {
                _uid: "d218a370-bedf-4c06-ab0c-c3593d20ef19",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "df56def8-f3ee-457a-bf33-b2746962fd81_e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ed73014a-a854-4649-876e-0cf100b71974",
                component: "col",
                label: [""],
                simplifiedLabel: ["8"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5743ddfe-e0f4-4be0-b769-c499ea77d1c0",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Identify users and authenticate access to system components",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d91076ae-a1e6-4aca-8f77-f4b61721f355",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["1206feba-b01d-4284-871f-6b56114cc49b"],
                },
              },
              {
                _uid: "1206feba-b01d-4284-871f-6b56114cc49b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "b546da83-5f01-46b5-b25d-6579d5374689_d91076ae-a1e6-4aca-8f77-f4b61721f355",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6d4ad0b7-0ba7-4c8b-80c6-a2a28e610800",
                component: "col",
                label: [""],
                simplifiedLabel: ["9"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "eabb273e-9804-4ea8-860a-7cef8b416ed6",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Restrict physical access to cardholder data",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "1120c4c9-880b-4787-a77c-d854d94c1501",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["48fdc1a5-b71e-44dc-a3a9-8425ea492c6a"],
                },
              },
              {
                _uid: "48fdc1a5-b71e-44dc-a3a9-8425ea492c6a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "662efa04-11e0-4262-ad45-977624cda7fe_1120c4c9-880b-4787-a77c-d854d94c1501",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dea416ea-1090-4822-a15b-0245c4d48062",
                component: "col",
                label: [""],
                simplifiedLabel: ["11"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6c7c3e23-4fda-4ce8-8842-e2b23e879a26",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Test security systems and networks regularly",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8542b132-8ccb-4a81-9b79-f820bc26ff56",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["a165d774-a674-435b-98c8-833d28279384"],
                },
              },
              {
                _uid: "a165d774-a674-435b-98c8-833d28279384",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "918afec2-8143-403d-aba9-be4cbcadb252_8542b132-8ccb-4a81-9b79-f820bc26ff56",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "93106548-c28e-4007-9f0f-6567043bbda6",
                component: "col",
                label: [""],
                simplifiedLabel: ["12"],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "66c5df27-b83a-404e-9d01-a8f2beb5fda2",
                component: "col",
                label: [""],
                simplifiedLabel: [
                  "Support information security with organizational policies and programs",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: ["50377fbd-8c89-4199-8ff4-30ad491f04a9"],
                },
              },
              {
                _uid: "50377fbd-8c89-4199-8ff4-30ad491f04a9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
                enabledOn: "no",
                conditional: {
                  value: "no",
                  field:
                    "b7e8f327-cc1f-434d-b945-058332bc69f3_b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
